import tw, { styled } from "twin.macro";

export const PhotoWrapper = styled.div`
	${tw`p-4 md:p-8 pb-0 `};
`;
export const UploadImageWrapper = styled.div`
	${tw`p-4 h-full bg-white w-full flex flex-col items-center justify-center`}
	height: 80vh;
	box-shadow: 0px 30px 60px rgba(32, 56, 85, 0.05);
	border-radius: 10px;
	@media (max-width: 1217px) {
		flex-direction: row;
		flex-wrap: nowrap;
		height: auto;
	}
`;
export const ImageMansoryWrapper = styled.div`
	height: calc(100vh - 11rem);
	overflow-y: scroll;

	.react-photo-gallery--gallery {
		img {
			border-radius: 10px;
			/* gap: 10px; */
		}
	}
`;